import Icon from '../components/Icon.vue'

Icon.register({
  'chevron-circle-left': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 504c-137 0-248-111-248-248s111-248 248-248 248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9l-101.6-101.6 101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0l-135.5 135.5c-9.4 9.4-9.4 24.6 0 34z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chevron-circle-left.js
// module id = 1186
// module chunks = 0